export default __webpack_public_path__ + "static/media/kidsworld.c1e9abcd.svg";